export const SET_IS_AUTH = Symbol();
export const SET_AUTH = Symbol();
